import Banner from "../../../../component/banner";
import WhyChoose from "../../../../component/why_choose";
import { SUB_DIRECTORY } from "../../../../common/constant";

const LandingSection = () => {

    return(
        <>
        {/* <Banner />
        <WhyChoose title="PINC"/> */}
          
           <img src={`${SUB_DIRECTORY}/assets/images/keypoints.png`}  className="img-fluid w-56" alt="" />
          
        
</>
)}
export default LandingSection
